export { default as TooltipTrigger } from './TooltipTrigger'
